export default "__VITE_ASSET__DQhrEoxX__"